import papa from 'papaparse'
import React from 'react'
import Body from './Body'
import Footer from './Footer'

const isValidHttpUr = link => {
  let url

  try {
    url = new URL(link)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}

const useGetSingleCityBasicTrackingPopup = ({
  onConfirm,
  onClose,
  isCanBeConfirmed,
  setCriticalError,
  setFile,
  error,
  setCodesTable,
  setWarning,
  citiesArray: campaignCitiesArray,

  isCodesUploading,
}) => {
  const title = 'Upload codes file'

  const onFileUpload = (entryFiles, ...rest) => {
    setCriticalError(null)
    setWarning(null)
    if (entryFiles.length) {
      setFile(entryFiles[0])
      papa.parse(entryFiles[0], {
        complete: function(results, file) {
          const data = results.data
          const code = data[1][0]
          const link = data[1][1]

          //Validate that required headers exist in file in A1:C1:
          if (
            data[0][0].trim().toUpperCase() !== 'CODE' ||
            data[0][1].trim().toUpperCase() !== 'LINK'
          ) {
            setCriticalError(
              'Header value missing or incorrect. Please follow the instructions in the template and try again.',
            )
            return
          }

          //If file does not contain any required values:
          if (code === '' || link === '') {
            setCriticalError(
              'No codes or links found in file. Please review and try again.',
            )
            return
          }

          if (code.length > 12) {
            setCriticalError('Codes can not be longer than 12 characters.')
            return
          }

          if (!isValidHttpUr(link)) {
            setCriticalError(
              <div>
                <div>Not valid URL.</div>
                <div>Wrong example: google.com</div>
                <div>
                  Correct example: https://www.google.com or
                  http://www.google.com
                </div>
              </div>,
            )
            return
          }

          const formattedData = [
            {
              code: code,
              link: link,
              cityId: campaignCitiesArray[0].id,
            },
          ]
          setCodesTable(formattedData)
        },
      })
    }
  }
  return {
    body: (
      <Body
        error={error}
        onFileUpload={onFileUpload}
        setError={setCriticalError}
        setFile={setFile}
      />
    ),
    footer: (
      <Footer
        onConfirm={onConfirm}
        onClose={onClose}
        isCanBeConfirmed={isCanBeConfirmed}
        isCodesUploading={isCodesUploading}
      />
    ),
    title: title,
  }
}

export default useGetSingleCityBasicTrackingPopup
